// Softmood — scripts propios. Prefijo sm-. Vanilla JS, sin librerías externas.
document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initCifras();
  initGaleriaProducto();
  initSelectorVariantes();
});

function initRevelado() {
  var els = document.querySelectorAll('.sm-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sm-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sm-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initCifras() {
  var els = document.querySelectorAll('[data-sm-cifra]');
  if (!els.length) return;
  var animado = new WeakSet();
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || animado.has(entry.target)) return;
        animado.add(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-sm-cifra')) || 0;
        var dur = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var prog = Math.min((ts - inicio) / dur, 1);
          var actual = Math.floor(prog * fin);
          el.textContent = actual.toLocaleString('es-ES');
          if (prog < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString('es-ES');
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-sm-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-sm-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-sm-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('sm-mini-activa'); });
      mini.classList.add('sm-mini-activa');
    });
  });
}

function initSelectorVariantes() {
  var form = document.querySelector('[data-sm-form-producto]');
  if (!form) return;
  var datos = form.querySelector('[data-sm-variantes-json]');
  if (!datos) return;
  var variantes;
  try {
    variantes = JSON.parse(datos.textContent);
  } catch (e) {
    return;
  }
  var selects = form.querySelectorAll('[data-sm-opcion]');
  var inputId = form.querySelector('[data-sm-variant-id]');
  var precioEl = document.querySelector('[data-sm-precio-actual]');
  var precioCompareEl = document.querySelector('[data-sm-precio-comparado]');
  var botonComprar = form.querySelector('[data-sm-boton-comprar]');
  if (!selects.length || !inputId) return;

  function variantePorOpciones() {
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variantes.find(function (v) {
      return v.opciones.every(function (val, i) { return val === valores[i]; });
    });
  }

  function actualizar() {
    var v = variantePorOpciones();
    if (!v) return;
    inputId.value = v.id;
    if (precioEl) precioEl.textContent = v.precio_formateado;
    if (precioCompareEl) {
      if (v.precio_comparado_formateado) {
        precioCompareEl.textContent = v.precio_comparado_formateado;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      if (v.disponible) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || botonComprar.textContent;
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}
